module.exports = __webpack_public_path__ + "img/zizhi2.db53ebab.png";